import React, { useState } from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js'
import UIButton from '../UI/UIButton'
import { toast } from 'react-toastify'
import config from '../../config'

function Checkout() {
  const { t } = useTranslation('translation')

  const [isLoading, setLoading] = useState(false)

  const stripe = useStripe()
  const elements = useElements()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${config.FRONT_BASE_URL}/payments-status`,
      },
    })

    if (error.type === 'card_error' || error.type === 'validation_error') {
      toast.error(error.message)
    } else {
      toast.error('An unexpected error occured.')
    }
    setLoading(false)
  }

  return (
    <form>
      <PaymentElement />
      <div className={css(styles.buttonContainer)}>
        <UIButton
          label={t('pages.payments.pay')}
          design="tertiaryLight"
          dynamicStyle={styles.button}
          withForwardChevron
          onClick={handleSubmit}
          disabled={!stripe || !elements || isLoading}
        />
      </div>
    </form>
  )
}

const styles = StyleSheet.create({
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    margin: '20px 0px',
  },
})

export default Checkout
